/* A screen that has nothing in it yet.
 *
 * It says what will be here, for the person reading, and nothing else. No
 * reason, no blocker, no timing — all of that is internal, and none of it means
 * anything to somebody administering churches.
 */
import { Link } from 'react-router-dom'

import { Card } from '@/components/ui/card'

export function NotBuiltPage({
  title,
  summary,
}: {
  title: string
  /** What this screen will do, in the product's own voice. */
  summary: string
}) {
  return (
    <div className="space-y-s4">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
      </header>

      <Card className="px-s4 py-s7 text-center">
        <p className="mx-auto max-w-[420px] text-base text-ink-2">{summary}</p>
        <p className="mt-s4">
          <Link
            to="/churches"
            className="text-base font-semibold text-brand hover:underline"
          >
            Back to Churches
          </Link>
        </p>
      </Card>
    </div>
  )
}
